import { colors } from "Constants";

export const containerStyle = {
  padding: 0,
  boxShadow: `0 4px 12px 0px rgba(${colors.black},0.16)`,
  top: "44px",
};
